// extracted by mini-css-extract-plugin
export default {"container":"TypeSelector_container__J70AH","button":"TypeSelector_button__Or8F7"};